// l10n status: partial
import { Button, /*Link,*/ Snackbar, Typography, CircularProgress } from "@mui/material"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import { CreateComponent } from "components/utils/CreateComponent"
import { RouteLink, useNavigateRouteAdd } from "components/utils/RouteUtils"
import React, { useEffect, useRef, useState, memo } from "react"
import { MovieTile } from "scenes/Recordings/components/MovieTile"
import { ROUTE_NAMES } from "site-ql/RouteConst"
import { rootStore } from "store/RootStore"
import { RecordingsSpaceInfo } from "./components/RecordingsSpaceInfo"
// MTVW-76 import { RecordingsEmpty } from "scenes/Recordings/components/RecordingsEmpty"
//import { fade } from "@mui/material/styles"
import { useParams, useNavigate, useLocation, Link } from "react-router"
import { ConfirmationDialog } from "components/ConfirmationDialog"
import { ButtonGeneric } from "scenes/components/ButtonComponents"
import { analyticsScreen, analyticsMeta } from "store/qlapi/LogService"
import { appFeatures } from "AppFeatures"
import { l10n } from "store/lang/L10n"

// MTVW-181
import './recordingList.css'

// eslint-disable-next-line no-unused-vars
let lastSection = ""

const styles = theme => ({
	// MTVW-181 only MaterialUI classes
	/* classes below are dedicated to delete recordings page*/
	rootSnackbar: {
		//width: theme.themeExtendedWidth,
		width: "100% !important",
		background: theme.palette.secondary.main,
		bottom: "0px !important",
		[theme.breakpoints.down("xs")]: {
			right: 0,
			left: 0,
			bottom: 0,
			width: "100%",
			//height: "90px",
			alignItems: "flex-end"
		},
	},
	rootButton: {
		margin: "0 12px",
	},
	backButtonText: {
		padding: 0,
	},
})

//MTVW-181 ok
const RecordingsDeleteNav = CreateComponent(null, false, false, ({ classes, page, isDelete, selectAll }) => {
	const navigate = useNavigate()
	const location = useLocation()

	return(
		<div className={"recordingsDeleteNav"}>
			{isDelete &&
				<Button size="medium" className={"selectAllRecordingButton"} onClick={() => selectAll()}>
					{l10n.commonActionSelectAll}
				</Button>
			}
			{/* MTVW-966: replaced to avoid problem when a serie is expanded
			{!isDelete &&
				<RouteLink name={"RecordingsList"} Component={Link} params={{ ...page.routeParams, isDelete: "delete"}}>
					<Button className={"recordingsIconDelete"} data-test="confirm">
					{l10n.commonActionEdit}
					</Button>
				</RouteLink>}
			*/}
			{!isDelete &&
				<Button className={"recordingsIconDelete"} data-test="confirm"
					onClick={() => navigate(location.pathname + "/delete")}>
					{l10n.commonActionEdit}
				</Button>
			}
		</div>
	)
})

//MTVW-181 ok
const RecordingsLoading = CreateComponent(null, false, true, ({ classes, source }) => (
	<>
		{source.isLoading && (
			<div className={"recordingsLoadingWrapper"}>
				<CircularProgress size={100} />
			</div>
		)}
	</>
))

// MTVW-212
let isRecordDeleted = false

const RecordingsBody = CreateComponent(styles, false, true, ({ classes, page }) => {
	// MTVW-966: use page.routeParams
	//const { type, isDelete, serieId } = useParams()
	const { type, isDelete, serieId } = page.routeParams
	const [tDeleteMark, setDeleteMark] = useState([])
	const refreshReq = useRef(Math.round(Math.random() * 10000))
	// MTVW-917
	const [confirmDelete, setConfirmDelete] = useState(false)

	const navigate = useNavigate()
	const location = useLocation()
	//console.debug("RecordingsBody type %o, isDelete %o, serieId %o, location %o, usePrams %o", type, isDelete, serieId, location, useParams())

	const toggleDeleteMark = (id, i) => {
		// MTVW-820: TODO, delete only completed or planned recordings on 'ALLE SERIENAUFNAHMEN' and 'ALLE GEPLANTEN AUFNAHMEN'
		/*
		console.debug("toggleDeleteMark", id, tDeleteMark.includes(id), actualSectionInfo, tDeleteMark.includes(id) ? tDeleteMark.filter(i => i !== id) : [...tDeleteMark, id])
		console.debug("toggleDeleteMark", page, page.recList.DataArr, page.routeParams.type, rootStore.page.Recordings.Manager.oRecMarkers)
		//const planned = rootStore.page.Recordings.Manager.oRecMarkers?._$Recording?.data_?.filter(item => item.State === "Scheduled")
		const planned = rootStore.page.Recordings.IndexPage.oRecPlanned
		console.debug("toggleDeleteMark", id, i, rootStore.page.Recordings.Manager.getMarker(null, i.SeriesId), planned)
		*/
		tDeleteMark.includes(id) ? setDeleteMark(tDeleteMark.filter(i => i !== id)) : setDeleteMark([...tDeleteMark, id])
	}
	// MTVW-124 scroll on top only at first loading
	useEffect(() => {
		window.scrollTo(0, 0)
		// MTVW-955
		const location = window.location.href
		if (location) {
			const section = location.substring(location.lastIndexOf("/") + 1)
			//console.debug("section list", section)
			let screen = ""
			switch (section) {
				case "newrecs":
					screen = analyticsScreen.newRecordings
					break
				case "single":
					screen = analyticsScreen.singleRecordings
					break
				case "series":
					screen = analyticsScreen.seriesRecordings
					break
				case "planned":
					screen = analyticsScreen.scheduledRecordings
					break
				case "archived":
					screen = analyticsScreen.archivedRecordings
					break
				default:
					if (location.indexOf("series_details") >= 0) screen = analyticsScreen.recordingEpisodes
					break
			}
			if (screen.length > 0) rootStore.logService.analyticsScreenview({ [analyticsMeta.screen]: screen })
		}
	}, [])
	// fix issue in MTV-3691 but fixed in MTV-2768a
	// useEffect(() => {
	// 	removeDeleteMarks()
	// }, [isDelete])

	// MTV-212 added for a better refresh of deleting of selected element
	// the selection is removed only after the refresh of the page
	// to better synchronize the deletion of the records with the deselection
	// fixes a weird ui behavior
	useEffect(() => {
		if (isRecordDeleted) {
			removeDeleteMarks()
		}
		// MTVW-1034: needs to be in useEffect to avoid rendering issues / warnings
		if (isRecList === false) {
			goBackForEmptySection()
		}
	})

	const removeDeleteMarks = () => {
		// fix issue in MTV-3691 but fixed in MTV-2768a
		if (isDelete) {
			navigate(-1)
		}
		setDeleteMark([])
		isRecordDeleted = false
	}

	const isRecList = page.recList?.isReady && page.recList?.DataArr?.length === 0 ? false : page.recList?.isReady ? true : null
	const isSeriesContainer = serieId !== void 0

	const selectAll = () => {
		if (tDeleteMark?.length === page.recList?.DataArr?.length) {
			setDeleteMark([])
		} else {
			let _recList = page.recList?.DataArr?.map(i => i.id)
			setDeleteMark([..._recList])
		}
	}

	//MTVW-181 ok
	const RecordingsDeleteSnackbar = CreateComponent(null, false, false, ({ classes, deleteNumber, handleCancelButton, handleOkButton }) => {

		const getNumberOfDeleteSelected = () => {
			let numberOfDeleteSelected = 0
			for (let i = 0; i < tDeleteMark.length; i++) {
				const entry = page.recList.DataArr.filter(j => j.id === tDeleteMark[i])
				//console.debug("entry", entry)
				if (entry?.[0]?.isSeries) numberOfDeleteSelected += entry?.[0]?.childRecordingsCount
				else numberOfDeleteSelected++
			}
			return numberOfDeleteSelected
		}

		// re-calculate deleteNumber with childRecordingsCount of delete selected series
		deleteNumber = getNumberOfDeleteSelected()

		return (
			<>
				<Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
					//MTVW-181 className={classes.recordingsBottomMenu + " CleBottomMenuWrapperResponsive"}
					classes={{ root: classes.rootSnackbar }}
					open={true}>
					<div className={"recordingsBottomMenuWrapper "}>
						<div className={"recordingDeleteBottomButtons"} >
							{/* MTV-3691: Safari issue. Don't need RouteLink, routing is managed in handleCancelButton with browser history  */}
							{/* <RouteLink Component={Link} params={{ isDelete: void 0 }}> */}
							<Button size="large"
								disableRipple={true}
								classes={{ root: classes.rootButton }}
								className={"recordingsBottomMenuButton"}
								onClick={handleCancelButton}>
								{l10n.commonActionCancel}
							</Button>

							<Button
								disabled={deleteNumber === 0}
								// eslint-disable-next-line jsx-a11y/no-autofocus
								disableRipple={true}
								autoFocus variant="contained"
								classes={{ root: classes.rootButton }}
								className={"recordingsBottomMenuButtonPrimary"}
								onClick={handleOkButton}>
								{l10n.commonActionDelete}
							</Button>
						</div>
						<div className={"recordingDeleteBottomMessage"} style={{ visibility: deleteNumber > 0 ? "visible" : "hidden" }}>
							<Typography variant="subtitle1" className={"recordingsBottomMenuItem"}>
								{deleteNumber <= 1 && l10n.featureRecordingsOneItemSelected}
								{deleteNumber > 1 && l10n.featureRecordingsMultipleItemsSelected?.format(deleteNumber)}
							</Typography>
						</div>
					</div>
				</Snackbar>

				{/* MTVW-917 */}
				{confirmDelete &&
					<ConfirmationDialog
						title={deleteNumber > 1 ? l10n.dialogDeleteRecordingsTitle : l10n.dialogDeleteRecordingTitle}
						onCloseHandler={() => { setConfirmDelete(false) }}
						bottomButtons={
							[{
								bType: ButtonGeneric,
								props: {
									bId: `buttonDeleteRecording_confirm`, variant: "primary",
									label: deleteNumber > 1 ? l10n.dialogDeleteRecordingsAction : l10n.dialogDeleteRecordingAction, // "Aufnahme(n) löschen?"
									onClick: function () {
										setConfirmDelete(false)
										handleDeleteRec()
									},
									dataTest: "confirm"
								}
							},
							{
								bType: ButtonGeneric,
								props: {
									bId: `buttonDeleteRecording_cancel`, variant: "secondary",
									label: l10n.commonActionCancel, // "Abbrechen"
									onClick: function () {
										setConfirmDelete(false)
									},
									dataTest: "cancel"
								}
							}
							]}
					>
						{deleteNumber > 1 ? l10n.dialogDeleteRecordingsMessage.replaceAll("\\n", "\n") : l10n.dialogDeleteRecordingMessage.replaceAll("\\n", "\n")}
					</ConfirmationDialog>
				}
			</>
		)
	})

	const handleDeleteRec = () => {
		rootStore.page.Recordings.Manager.recordingManager.handleDeleteRecordings({ Ids: tDeleteMark }, page.routeParams).then(() => {

			// MTVW-212 commented and added isRecordDeleted for a better refresh of the page 
			// page.refreshData()
			// removeDeleteMarks()

			isRecordDeleted = true
			page.refreshData() // the refresh data reload the page
		})
	}

	// MTVW-76 
	const goBackForEmptySection = () => {
		/**  MTVW-212 
		 * Need to check the path to know whether delete is active 
		 * 1) episodes of a series then the path is like http://localhost:3000/#/recordings/series/series_details/b81595bd-a2d1-45ee-be54-3ef78526f6e3
		 * 2) or recordings in a section then the path is like http://localhost:3000/#/recordings/series/
		*/
		let mainPath = location.pathname.substr(0, (location.pathname.indexOf(type) + type.length + 1))

		//console.debug("goBackForEmptySection", location.pathname, mainPath, type)
		if (location.pathname !== mainPath) {
			// MTVW-212 refer to the comment above if case 1 go back to /recordings/series/
			// the url for the page should no longer be on the stack because the page doesn't exist anymore.
			//history.replace(mainPath)
			navigate(mainPath, { replace: true })
			//history.goBack()
			navigate(-1)
		} else {
			mainPath = location.pathname.substr(0, (location.pathname.indexOf(type)))
			//history.push(mainPath)
			navigate(mainPath)
		} 	// MTVW-212 no need to replace: refer to the comment above, if case 2 go to /recordings/
	}

	const infoRecordingSections = {
		"oRecNew": {
			name: l10n.featureRecordingsNewRecordingsSectionAll.toUpperCase(),
		},
		"oRecSingle": {
			name: l10n.featureRecordingsSingleRecordingsSectionAll.toUpperCase(),
			route: ROUTE_NAMES.Recordings,
		},
		"oRecSeries": {
			name: l10n.featureRecordingsRecordingsSeriesSectionAll.toUpperCase(),
		},
		"oRecPlanned": {
			name: l10n.featureRecordingsScheduledRecordingsSectionAll.toUpperCase(),
		},
		"oRecArchived": {
			name: l10n.featureRecordingsArchivedRecordingsSectionAll.toUpperCase(),
		},
	}

	const actualSectionInfo = page.listName ? infoRecordingSections[page.listName] : infoRecordingSections[page.routeParams.type]
	refreshReq.current += 1

	return (
		<div className={"recordingsBody"}>
			{/* MTVW-181 NEVER-USED TO VERIFY: is this junk code? */}
			{/* <RecordingsFilter isFilterVisible={true} />
         <RecordingsSorting isSortVisible={page.isSortVisible} classes={classes} /> */}

			<div className={"recordingsGridListNarrow"}>
				<div className={"recordingsGridListHeader"}>
					<Typography variant="h6" onClick={() => {
						navigate(-1)
					}}>
						<Button aria-label="" classes={{ text: classes.backButtonText }} data-test="recording_back">
							<ArrowBackIcon /><span className={"backLinkTxt"}>{l10n.commonActionBack}</span>
						</Button>
					</Typography>
					{/* MTV-2171 added title in the bar */}
					<div className={"recordingTitleSection"}>
						<Typography className="recordingTitleText" noWrap variant="h6">{isSeriesContainer ? page.recList.DataMain?.Name : (actualSectionInfo.name)}</Typography>
					</div>

					<RecordingsDeleteNav classes={classes} page={page} isDelete={page.routeParams.isDelete} selectAll={selectAll} />
				</div>
				<div className={"recordingsGridContainer"}>
					{isRecList === false ? (
						// MTVW-1034: has to be done in useEffect to avoid rendering issues / warnings
						//goBackForEmptySection()
						// dummy statement needed for syntax
						console.debug("No recordings in this section, go back to previous page")
					) : (
						<div id="gridContainer" className={"recordingsGrid"}>
							{page.recList.DataArr?.map((i) => {
								const filtered = !appFeatures.showAdultContent && rootStore.channelsService?.isAdultChannel(i?.Channel?.id)
								if (!filtered) return (
									<MovieTile
										movie={i}
										key={i.id}
										// MTVW-1015: !isSeriesContainer instead of isSeriesContainer
										isShowEpisodeTitle={!isSeriesContainer}
										isDelete={isDelete}
										isDeleteSelected={isDelete && tDeleteMark.includes(i.id)}
										//MTV-3138 for have the same result from the overview on planned series and expanded planned recordings on the same series
										// added routeProps for not to lose the planned state from expanded planned section
										routeProps={page.routeParams}
										deleteMarkCallback={isDelete ? () => toggleDeleteMark(i.id, i) : null}
									/>)
								else return null
							})}
						</div>
					)}
					<RecordingsSpaceInfo refreshReq={refreshReq.current}/>
				</div>
			</div>
			{isDelete && <RecordingsDeleteSnackbar classes={classes} deleteNumber={tDeleteMark?.length} handleCancelButton={removeDeleteMarks} handleOkButton={() => { setConfirmDelete(true) }} />}
			<RecordingsLoading classes={classes} source={rootStore.page.Recordings.Manager.recordingManager} />
		</div>
	)
})

export const RecordingsList = CreateComponent(null, false, false, () => {
	const page = rootStore.page.Recordings.ListPage.setRouteParams(useParams())

	useEffect(() => {
		if (page.listName) {
			lastSection = page.listName
		}
	}, [page.listName])

	useEffect(...page.getMountBody())
	return <RecordingsBody page={page} />
})
